import { ActionType } from 'components/atoms/actions'

export const C_ACTION_PRESCRIPTION = {
  EditNote: ActionType.Common,
  EditQuantity: ActionType.Edit,
  EditPrescription: ActionType.Update,
  EditIndicationNote: ActionType.EditNote,
  EditDayOfUse: ActionType.EditDayOfUse,
  EditMorning: ActionType.EditMorning,
  EditMidday: ActionType.EditMidday,
  EditAfternoon: ActionType.EditAfternoon,
  EditNight: ActionType.EditNight,
  EditData: ActionType.EditData
}
